/* Emberlum — coin photo positioning ("mockup") editor.
   Optional. Lets the customer drag / size / rotate their photo inside the coin
   frame (with the decorative border drawn in). On submit it renders a high-res
   proof PNG + layout params into hidden line-item properties so we receive them.
   If the customer skips it, a default-centered proof is sent (adjusted=no) and
   our designers place the photo. */
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  var mockup = form.querySelector('[data-mockup]');
  if (!mockup) return;

  var toggle = mockup.querySelector('[data-mockup-toggle]');
  var panel = mockup.querySelector('[data-mockup-panel]');
  var adjustedInput = form.querySelector('[data-adjusted]');
  var clearBtn = mockup.querySelector('[data-mockup-clear]');
  var doneNote = mockup.querySelector('[data-mockup-done]');
  var frontFile = form.querySelector('input[name="properties[Photo]"]');
  var backFile = form.querySelector('input[name="properties[Back photo]"]');

  var DISPLAY = 480;   // on-screen canvas resolution
  var EXPORT = 760;    // proof (preview) resolution — a small JPEG so the cart preview is light.
                       // The customer's photo itself is uploaded untouched (full quality) so the
                       // engraver always receives the original; only this preview is compressed.

  var canSetFiles = (function () {
    try { var dt = new DataTransfer(); return 'items' in dt; } catch (e) { return false; }
  })();

  function selectedDesign() {
    var el = form.querySelector('input[name="opt-design"]:checked');
    return el ? el.value : null;
  }
  function holeSelected() {
    var el = form.querySelector('input[name="properties[Hole]"]:checked');
    return !!(el && /hole/i.test(el.value) && !/\bno\b/i.test(el.value));
  }

  function makeEditor(side) {
    var fig = mockup.querySelector('[data-editor="' + side + '"]');
    var canvas = fig.querySelector('[data-canvas]');
    canvas.width = DISPLAY; canvas.height = DISPLAY;
    var ctx = canvas.getContext('2d');
    var scaleCtl = fig.querySelector('[data-ctl="scale"]');
    var rotateCtl = fig.querySelector('[data-ctl="rotate"]');
    var resetBtn = fig.querySelector('[data-reset]');
    var proofInput = form.querySelector('[data-proof="' + side + '"]');
    var layoutInput = form.querySelector('[data-layout="' + side + '"]');

    var state = { img: null, url: null, ox: 0, oy: 0, scaleMul: 1, rot: 0, touched: false };

    function geom(S) {
      var rOut = S / 2 - S * 0.03;
      var rPhoto = rOut - S * 0.003;
      return { c: S / 2, rOut: rOut, rPhoto: rPhoto, rBorder: rOut - S * 0.024, amp: S * 0.018, d: 2 * rPhoto };
    }
    function baseFit(S) {
      if (!state.img) return 1;
      var g = geom(S);
      return Math.max(g.d / state.img.naturalWidth, g.d / state.img.naturalHeight);
    }

    // simple wavy ring — one clean undulating stroke (no thorns); photo shows through behind it
    function drawBorder(c2, cx, cy, rBase, amp, ratio) {
      c2.save(); c2.translate(cx, cy);
      c2.strokeStyle = '#8a5a30'; c2.lineJoin = 'round'; c2.lineCap = 'round';
      c2.lineWidth = Math.max(1, 1.6 * ratio);
      // phase so a crest lands at the top (-90deg), aligned under the hole
      var waves = 22, steps = waves * 10, top = -Math.PI / 2, phase = Math.PI / 2 - waves * top, i, t, r;
      c2.beginPath();
      for (i = 0; i <= steps; i++) {
        t = i / steps * 2 * Math.PI; r = rBase + amp * Math.sin(waves * t + phase);
        c2.lineTo(Math.cos(t) * r, Math.sin(t) * r);
      }
      c2.closePath(); c2.stroke();
      c2.restore();
    }

    function draw(c2, S) {
      var g = geom(S), ratio = S / DISPLAY;
      c2.clearRect(0, 0, S, S);
      // coin field (base; visible only at the thin rim, or behind a shrunk photo)
      var grad = c2.createRadialGradient(g.c - g.rOut * 0.3, g.c - g.rOut * 0.3, g.rOut * 0.2, g.c, g.c, g.rOut);
      grad.addColorStop(0, '#f3f1ec'); grad.addColorStop(0.6, '#d9dde0'); grad.addColorStop(1, '#aeb4ba');
      c2.save(); c2.beginPath(); c2.arc(g.c, g.c, g.rOut, 0, 2 * Math.PI); c2.fillStyle = grad; c2.fill(); c2.restore();
      // photo, clipped almost to the rim
      if (state.img) {
        c2.save();
        c2.beginPath(); c2.arc(g.c, g.c, g.rPhoto, 0, 2 * Math.PI); c2.clip();
        c2.translate(g.c + state.ox * ratio, g.c + state.oy * ratio);
        c2.rotate(state.rot);
        var s = baseFit(S) * state.scaleMul; c2.scale(s, s);
        c2.drawImage(state.img, -state.img.naturalWidth / 2, -state.img.naturalHeight / 2);
        c2.restore();
      } else {
        c2.save(); c2.beginPath(); c2.arc(g.c, g.c, g.rPhoto, 0, 2 * Math.PI);
        c2.fillStyle = 'rgba(120,120,120,.12)'; c2.fill(); c2.restore();
      }
      // decorative wavy border, drawn over the photo (lines only)
      drawBorder(c2, g.c, g.c, g.rBorder, g.amp, ratio);
      // rim
      c2.save(); c2.beginPath(); c2.arc(g.c, g.c, g.rOut, 0, 2 * Math.PI);
      c2.lineWidth = 2.4 * ratio; c2.strokeStyle = '#7f8489'; c2.stroke(); c2.restore();
      // hole at top
      if (holeSelected()) {
        c2.save();
        c2.beginPath(); c2.arc(g.c, g.c - g.rOut + S * 0.05, S * 0.022, 0, 2 * Math.PI);
        c2.fillStyle = 'rgba(40,46,52,.45)'; c2.fill();
        c2.lineWidth = 1.4 * ratio; c2.strokeStyle = 'rgba(70,78,86,.6)'; c2.stroke();
        c2.restore();
      }
    }
    function render() { draw(ctx, DISPLAY); }

    function reset() {
      state.ox = 0; state.oy = 0; state.scaleMul = 1; state.rot = 0; state.touched = false;
      scaleCtl.value = 100; rotateCtl.value = 0; render();
    }
    function setImage(file) {
      if (state.url) { URL.revokeObjectURL(state.url); state.url = null; }
      if (!file) { state.img = null; render(); refreshVisibility(); return; }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { state.img = img; state.url = url; reset(); refreshVisibility(); };
      img.onerror = function () { URL.revokeObjectURL(url); };
      img.src = url;
    }

    var dragging = false, lastX = 0, lastY = 0;
    function pt(e) {
      var r = canvas.getBoundingClientRect(), k = canvas.width / r.width;
      return { x: (e.clientX - r.left) * k, y: (e.clientY - r.top) * k };
    }
    canvas.addEventListener('pointerdown', function (e) {
      if (!state.img) return;
      dragging = true; try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
      var p = pt(e); lastX = p.x; lastY = p.y;
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var p = pt(e); state.ox += (p.x - lastX); state.oy += (p.y - lastY);
      lastX = p.x; lastY = p.y; state.touched = true; render();
    });
    function endDrag(e) { if (dragging) { dragging = false; try { canvas.releasePointerCapture(e.pointerId); } catch (_) {} } }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);

    scaleCtl.addEventListener('input', function () { state.scaleMul = (+scaleCtl.value) / 100; state.touched = true; render(); });
    rotateCtl.addEventListener('input', function () { state.rot = (+rotateCtl.value) * Math.PI / 180; state.touched = true; render(); });
    resetBtn.addEventListener('click', reset);

    function exportProof() {
      return new Promise(function (resolve) {
        if (!state.img) { resolve(false); return; }
        if (layoutInput) {
          layoutInput.value = JSON.stringify({
            ox: Math.round(state.ox), oy: Math.round(state.oy),
            scale: +state.scaleMul.toFixed(3),
            rotation: +(state.rot * 180 / Math.PI).toFixed(1),
            base: DISPLAY
          });
          layoutInput.disabled = false;
        }
        var off = document.createElement('canvas'); off.width = EXPORT; off.height = EXPORT;
        draw(off.getContext('2d'), EXPORT);
        if (!canSetFiles || !proofInput) { resolve('params'); return; }
        // flatten onto a light field so JPEG corners aren't black (the cart clips it to a circle anyway)
        var flat = document.createElement('canvas'); flat.width = EXPORT; flat.height = EXPORT;
        var fx = flat.getContext('2d'); fx.fillStyle = '#f3f1ec'; fx.fillRect(0, 0, EXPORT, EXPORT); fx.drawImage(off, 0, 0);
        flat.toBlob(function (blob) {
          if (!blob) { resolve('params'); return; }
          try {
            var dt = new DataTransfer();
            dt.items.add(new File([blob], 'proof-' + side + '.jpg', { type: 'image/jpeg' }));
            proofInput.files = dt.files; proofInput.disabled = false;
            resolve(true);
          } catch (e) { resolve('params'); }
        }, 'image/jpeg', 0.82);
      });
    }

    function ensureImage() {
      var fi = side === 'front' ? frontFile : backFile;
      if (!state.img && fi && fi.files && fi.files[0]) setImage(fi.files[0]);
    }
    function clear() {
      if (state.url) { URL.revokeObjectURL(state.url); state.url = null; }
      state.img = null; state.ox = 0; state.oy = 0; state.scaleMul = 1; state.rot = 0; state.touched = false;
      scaleCtl.value = 100; rotateCtl.value = 0;
      if (proofInput) { proofInput.disabled = true; try { proofInput.value = ''; } catch (_) {} }
      if (layoutInput) { layoutInput.disabled = true; layoutInput.value = ''; }
      render();
    }

    return {
      side: side, state: state, fig: fig, setImage: setImage, render: render, exportProof: exportProof,
      clear: clear, ensureImage: ensureImage,
      get active() { return !!state.img && !fig.hidden; }
    };
  }

  var editors = { front: makeEditor('front'), back: makeEditor('back') };

  function refreshVisibility() {
    var twoSides = selectedDesign() === 'Photo both sides';
    var hasFront = !!(frontFile && frontFile.files && frontFile.files[0]);
    var hasBack = !!(backFile && backFile.files && backFile.files[0]);
    mockup.hidden = !hasFront;
    editors.back.fig.hidden = !(twoSides && hasBack);
    editors.front.render();
    if (!editors.back.fig.hidden) editors.back.render();
  }

  function hideDone() { if (doneNote) doneNote.hidden = true; }

  toggle.addEventListener('click', function () {
    var open = panel.hidden;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      hideDone();
      editors.front.ensureImage(); editors.front.render();
      if (!editors.back.fig.hidden) { editors.back.ensureImage(); editors.back.render(); }
    }
  });

  if (clearBtn) clearBtn.addEventListener('click', function () {
    editors.front.clear(); editors.back.clear();
    if (adjustedInput) adjustedInput.value = 'no';
    panel.hidden = true; toggle.setAttribute('aria-expanded', 'false');
    if (doneNote) doneNote.hidden = false;
  });

  if (frontFile) frontFile.addEventListener('change', function () { hideDone(); editors.front.setImage(frontFile.files && frontFile.files[0]); });
  if (backFile) backFile.addEventListener('change', function () { hideDone(); editors.back.setImage(backFile.files && backFile.files[0]); });
  form.addEventListener('change', function (e) {
    if (e.target.name === 'opt-design' || e.target.name === 'properties[Hole]') refreshVisibility();
  });

  var addBtns = document.querySelectorAll('[data-add], .buybar__btn');
  function setBtns(txt, disabled) {
    for (var i = 0; i < addBtns.length; i++) {
      if (disabled != null) addBtns[i].disabled = disabled;
      if (txt != null) addBtns[i].textContent = txt;
    }
  }

  // animated ellipsis: the dots build up one at a time while we wait
  var dotsTimer = null;
  function setBtnsAnimated(base) {
    stopDots();
    var n = 0;
    setBtns(base + '.', true);
    dotsTimer = setInterval(function () {
      n = (n + 1) % 3;
      setBtns(base + new Array(n + 2).join('.'), true);
    }, 400);
  }
  function stopDots() {
    if (dotsTimer) { clearInterval(dotsTimer); dotsTimer = null; }
  }

  var submitting = false;

  // AJAX add-to-cart with a live upload read-out. The full-resolution photo can be a few MB,
  // so rather than a frozen page we show real progress, then land on the cart. Any problem
  // (no FormData/XHR, network error, non-2xx) falls back to a normal full-page form submit.
  function ajaxAdd() {
    var data;
    if (!('FormData' in window) || !('XMLHttpRequest' in window)) { form.submit(); return; }
    try { data = new FormData(form); } catch (e) { form.submit(); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (xhr.upload) xhr.upload.onprogress = function (ev) {
      if (!ev.lengthComputable) return;
      var pct = Math.round(ev.loaded / ev.total * 100);
      if (pct < 100) { stopDots(); setBtns('Uploading your photo... ' + pct + '%', true); }
      else { setBtnsAnimated('Almost there'); }
    };
    xhr.onload = function () {
      stopDots();
      if (xhr.status >= 200 && xhr.status < 300) { window.location.href = '/cart'; }
      else { form.submit(); }
    };
    xhr.onerror = function () { stopDots(); form.submit(); };
    setBtnsAnimated('Uploading your photo');
    xhr.send(data);
  }

  form.addEventListener('submit', function (e) {
    var hasFront = frontFile && frontFile.files && frontFile.files[0];
    if (submitting || !hasFront) return;
    e.preventDefault();
    submitting = true;
    setBtnsAnimated('Preparing your preview');
    var jobs = [editors.front.exportProof()];
    if (editors.back.active) jobs.push(editors.back.exportProof());
    var touched = editors.front.state.touched || (editors.back.active && editors.back.state.touched);
    if (adjustedInput) adjustedInput.value = touched ? 'yes' : 'no';
    Promise.all(jobs).then(ajaxAdd).catch(function () { stopDots(); form.submit(); });
  });

  refreshVisibility();
})();
